// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-icon {
  margin-right: 15px; 
}

footer {
  color: #000000; 
  text-align: center;
  padding: 20px 0; 
  font-family: 'Helvetica Neue', Arial, sans-serif; 
  font-size: 14px;
}

footer a {
  color: #1abc9c; 
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease; 
}

footer a:hover {
  color: #16a085; 
}

footer p {
  margin: 0;
  line-height: 1.6; 
}

footer p a {
  margin: 0 10px; 
}

footer p::before {
  content: '•'; 
  margin-right: 10px;
  color: #bdc3c7; 
}

.privacy-text a {
  color: #1abc9c;
  text-decoration: none; 
  font-weight: bold;
  transition: color 0.3s ease; 
}

.privacy-text a:hover {
  color: #16a085; 
}

.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1); 
  border-left: 8px solid #2196f3;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f4f4f9;
}

header {
  background-color: #282c34;
  color: white;
  padding: 14px; 
  text-align: center;
}

nav a {
  margin: 0 10.5px; 
  color: white;
  text-decoration: none;
}

#about {
  padding: 35px 14px; 
  text-align: justify;
  margin: 0 auto;
  max-width: 640.5px; 
  box-sizing: border-box;
}

.profile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.profile-picture {
  width: 105px; 
  height: 105px; 
  border-radius: 50%;
  object-fit: cover;
  border: 1.4px solid #ddd; 
  position: relative;
  box-shadow: 0 0 7px rgba(0, 150, 255, 0.8); 
}

.profile-picture::before {
  content: '';
  position: absolute;
  top: -5.6px; 
  left: -5.6px; 
  right: -5.6px; 
  bottom: -5.6px; 
  border-radius: 50%;
  border: 2.1px solid rgba(0, 150, 255, 0.8); 
  z-index: -1;
}

.profile-details {
  margin-top: 14px; 
  text-align: center;
  margin-left: 12px;
  margin-right: 12px;
}

.profile-details h2 {
  font-size: 1.26em; 
  margin: 0;
}

.tag {
  font-size: 0.56em; 
  color: #888;
  margin-left: 7px; 
}

.profile-details h3 {
  font-size: 0.84em; 
  color: #666;
  margin-top: 3.5px; 
}

.description {
  font-size: 0.7em; 
  margin: 10.5px 0; 
  max-width: 640.5px; 
  color: #444;
}

.profile-actions {
  display: flex;
  gap: 7px; 
  justify-content: center;
  width: 100%;
  max-width: 640.5px; 
  margin: 14px auto 0; 
}

.btn {
  flex: 1 1;
  padding: 7px; 
  border-radius: 3.5px; 
  font-size: 0.7em; 
  cursor: pointer;
  border: none;
}

.follow-btn {
  background-color: #0095f6;
  color: white;
}

.message-btn, .email-btn {
  background-color: #efefef;
  color: #333;
}

.btn:hover {
  opacity: 0.8;
}

#projects {
  padding: 7px; 
  display: flex;
  justify-content: center;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2px;
  box-sizing: border-box;
  width: 100%;
}

.project-card {
  position: relative;
  width: 100%;
  max-width: 210px; 
  height: auto;
  overflow: hidden;
  cursor: pointer;
}

.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

label {
  font-size: 14px;
  color: #555;
}

input[type="email"],
input[type="text"],
textarea {
  width: calc(100% - 20px);
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

textarea {
  height: 100px;
  resize: vertical;
}

button[type="submit"] {
  background: #0095f6;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

button.btn {
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}


.success-message {
  text-align: center;
}

.success-message p {
  color: #000000;
  font-family: Arial, Helvetica, sans-serif;
  font-size:20px;
}


.project-card:hover .overlay {
  opacity: 1;
}

.project-info {
  color: white;
  text-align: center;
}

h3 {
  margin: 0;
}

p {
  margin-top: 7px; 
  font-size: 0.63em; 
}

@media (min-width: 1024px) {
  .profile-container {
    flex-direction: row;
    text-align: left;
  }

  .profile-picture {
    margin-right: 14px; 
  }

  .profile-details {
    text-align: left;
  }

  .profile-actions {
    gap: 7px; 
  }

  .grid-container {
    display: grid;
    width: 640.5px; 
    gap: 2px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    box-sizing: border-box;
  }
}


@media (max-width: 1024px) {


  .profile-container {
    flex-direction: column;
    text-align: center;
  }

  .profile-picture {
    margin: 0 auto 7px; 
    min-width: 90px;
    min-height: 90px;
  }

  .profile-details {
    margin-top: 7px; 
    text-align: left;
  }

  .profile-actions {
    gap: 1.4px; 
    flex-direction: row;
    align-items: center;
    margin-top: 7px; 
    max-width: 100%;
  }

  .grid-container {
    display: grid;
    width: 640.5px; 
    gap: 2px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    box-sizing: border-box;
  }
}

@media (max-width: 480px) {
  .profile-picture {
    width: 70px; 
    height: 70px; 
  }

  .profile-details h2 {
    font-size: 0.84em; 
  }

  .profile-details h3 {
    font-size: 0.63em; 
  }

  .description {
    font-size: 0.56em; 
  }

  .btn {
    padding: 4.2px 8.4px; 
    font-size: 0.56em; 
  }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8); 
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 10%; 
}

.popup-content {
  background: #fff;
  width: 100%;
  max-width: 800px; 
  height: auto;
  max-height: 90vh;
  position: relative;
  overflow: hidden;
  box-sizing: border-box; 
  display: flex;
  flex-direction: column;
}

.progress-bar-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 3.5px; 
}

.progress-bar {
  height: 100%;
  background-color: #4fb6ff;
  transition: width 0.3s ease-in-out;
}

.popup-indicator {
  position: absolute;
  left: 0;
  right: 0;
  height: 3.5px; 
  background: rgba(255, 255, 255, 0.3);
}

.popup-content-btn {
  background: #fff;
  width: 100%;
  max-width: 800px;
  height: auto;
  max-height: 90vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 5%; 
  box-sizing: border-box; 
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,cAAc;AAChB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;IACR,gDAAgD;IAChD,sBAAsB;EACxB;AACF;;;AAGA;;;EAGE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;IACR,gDAAgD;IAChD,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".social-icon {\n  margin-right: 15px; \n}\n\nfooter {\n  color: #000000; \n  text-align: center;\n  padding: 20px 0; \n  font-family: 'Helvetica Neue', Arial, sans-serif; \n  font-size: 14px;\n}\n\nfooter a {\n  color: #1abc9c; \n  text-decoration: none;\n  font-weight: bold;\n  transition: color 0.3s ease; \n}\n\nfooter a:hover {\n  color: #16a085; \n}\n\nfooter p {\n  margin: 0;\n  line-height: 1.6; \n}\n\nfooter p a {\n  margin: 0 10px; \n}\n\nfooter p::before {\n  content: '•'; \n  margin-right: 10px;\n  color: #bdc3c7; \n}\n\n.privacy-text a {\n  color: #1abc9c;\n  text-decoration: none; \n  font-weight: bold;\n  transition: color 0.3s ease; \n}\n\n.privacy-text a:hover {\n  color: #16a085; \n}\n\n.spinner {\n  border: 8px solid rgba(0, 0, 0, 0.1); \n  border-left: 8px solid #2196f3;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 20px auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\nbody {\n  font-family: Arial, sans-serif;\n  margin: 0;\n  padding: 0;\n  background-color: #f4f4f9;\n}\n\nheader {\n  background-color: #282c34;\n  color: white;\n  padding: 14px; \n  text-align: center;\n}\n\nnav a {\n  margin: 0 10.5px; \n  color: white;\n  text-decoration: none;\n}\n\n#about {\n  padding: 35px 14px; \n  text-align: justify;\n  margin: 0 auto;\n  max-width: 640.5px; \n  box-sizing: border-box;\n}\n\n.profile-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-picture {\n  width: 105px; \n  height: 105px; \n  border-radius: 50%;\n  object-fit: cover;\n  border: 1.4px solid #ddd; \n  position: relative;\n  box-shadow: 0 0 7px rgba(0, 150, 255, 0.8); \n}\n\n.profile-picture::before {\n  content: '';\n  position: absolute;\n  top: -5.6px; \n  left: -5.6px; \n  right: -5.6px; \n  bottom: -5.6px; \n  border-radius: 50%;\n  border: 2.1px solid rgba(0, 150, 255, 0.8); \n  z-index: -1;\n}\n\n.profile-details {\n  margin-top: 14px; \n  text-align: center;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\n.profile-details h2 {\n  font-size: 1.26em; \n  margin: 0;\n}\n\n.tag {\n  font-size: 0.56em; \n  color: #888;\n  margin-left: 7px; \n}\n\n.profile-details h3 {\n  font-size: 0.84em; \n  color: #666;\n  margin-top: 3.5px; \n}\n\n.description {\n  font-size: 0.7em; \n  margin: 10.5px 0; \n  max-width: 640.5px; \n  color: #444;\n}\n\n.profile-actions {\n  display: flex;\n  gap: 7px; \n  justify-content: center;\n  width: 100%;\n  max-width: 640.5px; \n  margin: 14px auto 0; \n}\n\n.btn {\n  flex: 1;\n  padding: 7px; \n  border-radius: 3.5px; \n  font-size: 0.7em; \n  cursor: pointer;\n  border: none;\n}\n\n.follow-btn {\n  background-color: #0095f6;\n  color: white;\n}\n\n.message-btn, .email-btn {\n  background-color: #efefef;\n  color: #333;\n}\n\n.btn:hover {\n  opacity: 0.8;\n}\n\n#projects {\n  padding: 7px; \n  display: flex;\n  justify-content: center;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 2px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.project-card {\n  position: relative;\n  width: 100%;\n  max-width: 210px; \n  height: auto;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.project-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nlabel {\n  font-size: 14px;\n  color: #555;\n}\n\ninput[type=\"email\"],\ninput[type=\"text\"],\ntextarea {\n  width: calc(100% - 20px);\n  padding: 10px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\ntextarea {\n  height: 100px;\n  resize: vertical;\n}\n\nbutton[type=\"submit\"] {\n  background: #0095f6;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\nbutton.btn {\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n.success-message {\n  text-align: center;\n}\n\n.success-message p {\n  color: #000000;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size:20px;\n}\n\n\n.project-card:hover .overlay {\n  opacity: 1;\n}\n\n.project-info {\n  color: white;\n  text-align: center;\n}\n\nh3 {\n  margin: 0;\n}\n\np {\n  margin-top: 7px; \n  font-size: 0.63em; \n}\n\n@media (min-width: 1024px) {\n  .profile-container {\n    flex-direction: row;\n    text-align: left;\n  }\n\n  .profile-picture {\n    margin-right: 14px; \n  }\n\n  .profile-details {\n    text-align: left;\n  }\n\n  .profile-actions {\n    gap: 7px; \n  }\n\n  .grid-container {\n    display: grid;\n    width: 640.5px; \n    gap: 2px;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    box-sizing: border-box;\n  }\n}\n\n\n@media (max-width: 1024px) {\n\n\n  .profile-container {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .profile-picture {\n    margin: 0 auto 7px; \n    min-width: 90px;\n    min-height: 90px;\n  }\n\n  .profile-details {\n    margin-top: 7px; \n    text-align: left;\n  }\n\n  .profile-actions {\n    gap: 1.4px; \n    flex-direction: row;\n    align-items: center;\n    margin-top: 7px; \n    max-width: 100%;\n  }\n\n  .grid-container {\n    display: grid;\n    width: 640.5px; \n    gap: 2px;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 480px) {\n  .profile-picture {\n    width: 70px; \n    height: 70px; \n  }\n\n  .profile-details h2 {\n    font-size: 0.84em; \n  }\n\n  .profile-details h3 {\n    font-size: 0.63em; \n  }\n\n  .description {\n    font-size: 0.56em; \n  }\n\n  .btn {\n    padding: 4.2px 8.4px; \n    font-size: 0.56em; \n  }\n}\n\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8); \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 10%; \n}\n\n.popup-content {\n  background: #fff;\n  width: 100%;\n  max-width: 800px; \n  height: auto;\n  max-height: 90vh;\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box; \n  display: flex;\n  flex-direction: column;\n}\n\n.progress-bar-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  height: 3.5px; \n}\n\n.progress-bar {\n  height: 100%;\n  background-color: #4fb6ff;\n  transition: width 0.3s ease-in-out;\n}\n\n.popup-indicator {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 3.5px; \n  background: rgba(255, 255, 255, 0.3);\n}\n\n.popup-content-btn {\n  background: #fff;\n  width: 100%;\n  max-width: 800px;\n  height: auto;\n  max-height: 90vh;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 5%; \n  box-sizing: border-box; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
